// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u_9ORB95x0A7KkIwHYX4{gap:8px;width:100%;display:flex}.v88ao9J8_kx3gFLxTy4j{height:40px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `u_9ORB95x0A7KkIwHYX4`,
	"actionButton": `v88ao9J8_kx3gFLxTy4j`
};
export default ___CSS_LOADER_EXPORT___;
